export class User {
  userID: number;
  userName: string;
  firstName: string;
  lastName: string;
  emailID: string;
  password: string;
  RoleId: number;
  IsActive: number;
  CountryID: number;
  createdDate: string;
  ModifiedBy: number;
  ModifiedDate: string;
  PhoneNumber: string;
  AddressLine1: string;
  AddressLine2: string;
  AddressLine3: string;
  City: string;
  PostCode: string;
  CountyID: number;
  CreatedBy: number;
  Mobilenumber: string;
  companyID: number;
  IsAdmin: number;
  IsSuperAdmin: boolean;
  AdminID: number;
  SuperAdminID: number;
  CountyName: string;
  UserType: string;
  IsSessionLogged: boolean;
  isUserLoggedIn: boolean;
  userCompanyName: string;
  RegistrationType: string;
  NoOfUsers: number;
  NoOfCompanies: number;
  lastAccessCID: number;
  lastAccessApID: number;
  LastAccessCIDDate: string;
  isOpenLastCID: number;
  token?: string;
  centralUserID: number;
  lastLoggedIn: Date;
  lastLoggedOut: Date;
  accountingPeriod: string;
  userLoginHistory_ID: number
  saveType: string;
  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }
}
